var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C11.4469 2 11 2.44687 11 3C11 3.55313 11.4469 4 12 4H14.5844L8.29062 10.2937C7.9 10.6844 7.9 11.3188 8.29062 11.7094C8.68125 12.1 9.31563 12.1 9.70625 11.7094L16 5.41563V8C16 8.55312 16.4469 9 17 9C17.5531 9 18 8.55312 18 8V3C18 2.44687 17.5531 2 17 2H12ZM4.5 5C3.11875 5 2 6.11875 2 7.5V15.5C2 16.8813 3.11875 18 4.5 18H12.5C13.8813 18 15 16.8813 15 15.5V13C15 12.4469 14.5531 12 14 12C13.4469 12 13 12.4469 13 13V15.5C13 15.775 12.775 16 12.5 16H4.5C4.225 16 4 15.775 4 15.5V7.5C4 7.225 4.225 7 4.5 7H7C7.55312 7 8 6.55312 8 6C8 5.44688 7.55312 5 7 5H4.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.99a8b51f1f860ff136733b2c860755b4.svg";
export { ForwardRef as ReactComponent };